import { ENV } from '../../config/env';
import { Recurring } from "../../types/register";

export type ProductType = {
  id: string
  name: string
  durationMonths: number
  price: number
  billingCycle: string | undefined
  product: string
  introductoryDiscount?: number
  trialPeriod: number;
  recurring: Recurring[];
}

const developmentProducts: ProductType[] = [
  {
    id: 'price_1J4csRAb6wabgBHHTbrAfLWY',
    name: 'Annual',
    durationMonths: 12,
    price: 99.99,
    billingCycle: 'annually',
    product: 'prod_JKV1mMCOhNQ9oB',
    introductoryDiscount: 149,
    trialPeriod: 14,
    recurring: [
      {
        interval: 'year',
        interval_count: 1
      },
    ]
  },
  {
    id: 'price_1J4bNnAb6wabgBHHtgslYD5x',
    name: '3 months',
    durationMonths: 3,
    price: 49.99,
    billingCycle: 'quarterly',
    product: 'prod_JKV13tKzqa9EeZ',
    trialPeriod: 14,
    recurring: [
      {
        interval: 'month',
        interval_count: 3
      },
    ]
  }
]

const productionProducts: ProductType[] = [
  {
    id: 'price_1J4eH6Ab6wabgBHHBxGDli6i',
    name: 'Annual',
    durationMonths: 12,
    price: 99.99,
    billingCycle: 'annually',
    product: 'prod_JcWChoZd7oGDJn',
    introductoryDiscount: 149,
    trialPeriod: 14,
    recurring: [
      {
        interval: 'year',
        interval_count: 1
      },
    ]
  },
  {
    id: 'price_1J4eHeAb6wabgBHHkVMQ4lCW',
    name: '3 months',
    durationMonths: 3,
    price: 49.99,
    billingCycle: 'quarterly',
    product: 'prod_JcWC04k2CSdH93',
    trialPeriod: 14,
    recurring: [
      {
        interval: 'month',
        interval_count: 3
      },
    ]
  }
]


export const products = !ENV.isProduction ? developmentProducts : productionProducts